<template>
  <main-content with_go_back_bar>
      <kt-panel>
        <div class="create-services">
          <router-link to="/items" class="mr-2">
            <button class="btn btn-success">بازگشت</button>
          </router-link>
        </div>
          <form @submit.prevent="submit($event, query)"
                id="single-request-form"
                class="kt-form p-3 my-4"
                v-if="detailCustomerStatus == 'success'"
          >
              <div class="container p-3 pt-5 my-4 border in-border-header" style="padding-top: 1.5rem !important;">
                  <kt-form-section is_first>
                      <div class="section-header online-factor-dark-legend">
                          {{ $t('online-factor.label_create_customer') }}
                      </div>
                      <kt-row class="p-2">
                          <kt-col  lg="6" md="6" xs="12">
                              <kt-form-group>
                                  <kt-form-label for="status">
                                      {{ $t('online-factor.customer_type') }}
                                  </kt-form-label>
                                  <kt-form-select
                                      v-model="detailCustomer.customer_type"

                                  >
                                      <option
                                          value="1"
                                          :selected="detailCustomer.customer_type== '1'"
                                      >
                                          حقوقی
                                      </option>
                                      <option
                                          value="2"
                                          :selected="detailCustomer.customer_type== '2'"
                                      >
                                          حقیقی
                                      </option>
                                  </kt-form-select>

                              </kt-form-group>
                          </kt-col>
                          <kt-col lg="6" md="6" xs="12">
                              <kt-form-group>
                                  <kt-form-label for="legal_business_name">
                                      {{ $t('online-factor.legal_business_name') }}
                                      <span class="text-danger h5 pb-3">*</span>
                                  </kt-form-label>
                                  <kt-form-control id="legal_business_name" name="legal_business_name" v-model="detailCustomer.legal_business_name"
                                                   :disabled="detailCustomer.customer_type =='2'">
                                  </kt-form-control>
                              </kt-form-group>
                          </kt-col>
                          <kt-col lg="6" md="6" xs="12">
                              <kt-form-group>
                                  <kt-form-label for="real_first_name" >
                                      {{ $t('online-factor.real_first_name') }}
                                      <span class="text-danger h5 pb-3">*</span>
                                  </kt-form-label>
                                  <kt-form-control id="real_first_name" name="real_first_name" v-model="detailCustomer.real_first_name"
                                                   :disabled="detailCustomer.customer_type =='1'">
                                  </kt-form-control>
                              </kt-form-group>
                          </kt-col>
                          <kt-col lg="6" md="6" xs="12">
                              <kt-form-group>
                                  <kt-form-label for="real_last_name">
                                      {{ $t('online-factor.real_last_name') }}
                                  </kt-form-label>
                                  <kt-form-control id="real_last_name" name="real_last_name" v-model="detailCustomer.real_last_name"
                                                   :disabled="detailCustomer.customer_type =='1'">
                                  </kt-form-control>
                              </kt-form-group>
                          </kt-col>

                          <kt-col lg="6" md="6" xs="12">
                              <kt-form-group>
                                  <kt-form-label for="mobile">
                                      {{ $t('online-factor.mobile') }}
                                      <span class="text-danger h5 pb-3">*</span>
                                  </kt-form-label>
                                  <kt-form-control id="mobile" name="mobile" dir="ltr" v-model="detailCustomer.mobile">
                                  </kt-form-control>
                              </kt-form-group>
                          </kt-col>
                          
                          <kt-col lg="6" md="6" xs="12">
                              <kt-form-group>
                                  <kt-form-label for="email">
                                      {{ $t('online-factor.email') }}
                                      <span class="text-danger h5 pb-3">*</span>
                                  </kt-form-label>
                                  <kt-form-control id="email" name="email" v-model="detailCustomer.email">
                                  </kt-form-control>
                              </kt-form-group>
                          </kt-col>
                          <kt-col lg="12" md="12" xs="12">
                            <p class="badge badge-danger"> در صورت انتخاب فیلد تلفن همراه فیلد ایمیل اختیاری خواهد بود</p>
                          </kt-col>
                          <kt-col lg="6" md="6" xs="12">
                              <kt-form-group>
                                  <kt-form-label for="phone">
                                      {{ $t('online-factor.phone') }}
                                  </kt-form-label>
                                  <kt-form-control id="phone" name="phone" v-model="detailCustomer.phone">
                                  </kt-form-control>
                              </kt-form-group>
                          </kt-col>
                          <kt-col lg="6" md="6" xs="12">
                          <kt-form-group>
                            <kt-form-label for="province">
                              {{ $t('label.province') }}
                            </kt-form-label>
                            <select
                                id="province"
                                name="province"
                                v-model="detailCustomer.province"
                                class="form-control kt-selectpicker"
                                @change="loadCities(false)"
                            >
                              <option
                                  v-bind:key="province.key"
                                  v-for="province in provinces"
                                  :value="province.id"
                              >
                                {{ province.value }}
                              </option>
                            </select>
                          </kt-form-group>
                        </kt-col>
                          <kt-col lg="6" md="6" xs="12">
                              <kt-form-group>
                                  <kt-form-label for="national_code">
                                      {{ $t('online-factor.national_code') }}
                                  </kt-form-label>
                                  <kt-form-control id="national_code" name="national_code" v-model="detailCustomer.national_code">
                                  </kt-form-control>
                              </kt-form-group>
                          </kt-col>
                          <kt-col lg="6" md="6" xs="12">
                          <kt-form-group>
                              <kt-form-label for="city">
                                  {{ $t('label.city') }}
                              </kt-form-label>
                              <div id="city_select_holder">
                                  <select
                                      id="city_customer"
                                      name="city_customer"
                                      class="form-control"
                                      v-model="detailCustomer.city"
                                  >
                                  </select>
                                  <option class="optionCityDetails">{{ detailCustomer.city }}</option>
                              </div>
                          </kt-form-group>
                      </kt-col>
                          <kt-col lg="6" md="6" xs="12">
                              <kt-form-group>
                                  <kt-form-label for="address">
                                      {{ $t('online-factor.address') }}
                                  </kt-form-label>
                                  <kt-form-control id="address" name="address" v-model="detailCustomer.address">
                                  </kt-form-control>
                              </kt-form-group>
                          </kt-col>
                          <kt-col lg="6" md="6" xs="12">
                              <kt-form-group>
                                  <kt-form-label for="postal_code">
                                      {{ $t('online-factor.postal_code') }}
                                  </kt-form-label>
                                  <kt-form-control id="postal_code" name="postal_code" v-model="detailCustomer.postal_code">
                                  </kt-form-control>
                              </kt-form-group>
                          </kt-col>
                          <kt-col lg="6" md="6" xs="12">
                              <kt-form-group>
                                  <kt-form-label for="file">
                                      <kt-icon type="fa" name="paperclip"></kt-icon>
                                      {{ $t('online-factor.image') }}
                                  </kt-form-label>
                                  <kt-form-control
                                      @change="processFile"
                                      type="file"
                                      class="custom-file-upload"
                                      name="file"
                                      id="file"
                                      accept=".jpg"/>
                              </kt-form-group>
                          </kt-col>
                          <kt-col lg="6" md="6" xs="12">
                              <img v-if="detailCustomer.image !== null" id="logo_preview"  class="preview_img"/>
                              <img src="../../assets/media/customer.png" alt="" class="preview_img" v-else>
                          </kt-col>
                          <kt-col lg="12" md="12" xs="12">
                              <kt-button
                                  id="form-btn"
                                  class="btn btn-success btn-wide text-center py-2"
                                  type="submit"
                                  variant="success"
                                  @click="submit()"
                              >
                                  به روزرسانی
                              </kt-button>
                          </kt-col>
                          <kt-col lg="12" md="12" xs="12">

                          </kt-col>
                      </kt-row>
                  </kt-form-section>
              </div>
          </form>
      </kt-panel>
  </main-content>
</template>

<script>

import $ from "jquery";
import toastr from 'toastr';
import { KTApp } from '@/plugins/core/app'
import {mapGetters} from "vuex";
import mainContent from '@/components/main-content'
import { provinces, fullCities } from '@/constants/provinceCities'
import { onlineFactorService } from '@/common/shop.service';


export default {
  components: {
    'main-content': mainContent,
  },
    props: {
        submitSingleRequest: {
            default: function($event, query) {},
            type: Function
        },
    },
    data() {
        return {
            provinces: provinces,
            query: {
                 is_unlimited: false,
            },
            hashid: this.$route.params.hashid,
            editable : true,
            allCity:[]

        }
    },
    computed : {
      ...mapGetters('moneyRequest', [
        'detailCustomer',
          'detailCustomerStatus'
      ]),
      toastr() {
        toastr.options = {
          closeButton: true,
          positionClass: "toast-bottom-center",
          preventDuplicates: false,
          rtl: false
        }
        return toastr
      },
    },
    mounted() {
        this.$store.dispatch('moneyRequest/showCustomer',this.$route.params.hashid).then( response => {
        let output = document.getElementById('logo_preview');
          output.src = this.detailCustomer.image;
          output.onload = function() {
            URL.revokeObjectURL(output.src) // free memory
          },
          error => {
            
            }
        }
      )
        this.loadCities(true);
    },
    methods: {
        loadCities(load_city) {
          let province = $('#province')

            let city_select_holder = document.getElementById('city_select_holder');
            city_select_holder.innerHTML = ''
            let cities_element = document.createElement("select");
            cities_element.id = 'city';
            cities_element.name = 'city';
            cities_element.className = 'form-control';


            cities_element.onchange = function(){
                this.detailCustomer.city = $('#city').val()
            }.bind(this);

            city_select_holder.appendChild(cities_element)

              let province_val = province.find(":selected").val()

              let m_cities = Object.entries(fullCities)
              let cities

          m_cities.forEach(function (item) {
            if (item[0] == province_val) {
                cities = item[1]
            }
          })

          this.allCity = cities

          for(let x in this.allCity){
              let option = document.createElement("option")
              option.text = this.allCity[x];
              option.value = this.allCity[x];
              cities_element.appendChild(option)
          }
            if (load_city)
                $('#city').val(this.detailCustomer.city)



            $('#city').selectpicker({
                size: 6,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })


            $('#city').selectpicker({
            size: 6,
            liveSearch: true,
            noneResultsText: i18n.t('selectpicker.none_result'),
            selectAllText: i18n.t('selectpicker.select_all'),
            noneSelectedText: i18n.t('selectpicker.nothing_selected')
          })
        },
      submit(e, query) {
        let form = $('#single-request-form')
        let btn = $('#form-btn')

        form.validate({
          rules: {
              customer_type: {
                  required: true
              },
              real_first_name: {
                  required: true
              },
              real_last_name: {
                  required: false,
              },
              mobile: {
                  required: this.detailCustomer.email ? false : true,
              },
              email: {
                  required: this.detailCustomer.mobile ? false : true,
              },
              legal_business_name: {
                  required: this.detailCustomer.customer_type == '2' ? true : false
              },
          }
        })

        if (!form.valid())
          return;

        KTApp.progress(btn)
        let formData = new FormData();
        formData.append('customer_type',this.detailCustomer.customer_type)
        formData.append('real_first_name',this.detailCustomer.real_first_name)
        formData.append('real_last_name',this.detailCustomer.real_last_name)
        formData.append('email',this.detailCustomer.email ? this.detailCustomer.email : "")
        formData.append('mobile',this.detailCustomer.mobile ? this.detailCustomer.mobile : "")
        formData.append('legal_business_name',this.detailCustomer.legal_business_name)
        formData.append('address',this.detailCustomer.address ? this.detailCustomer.address : "")
        formData.append('province',this.detailCustomer.province ? this.detailCustomer.province : "")
        formData.append('city',this.detailCustomer.city ? this.detailCustomer.city : "")
        formData.append('phone',this.detailCustomer.phone ? this.detailCustomer.phone : "")
        formData.append('postal_code',this.detailCustomer.postal_code ? this.detailCustomer.postal_code : "")
        formData.append('national_code',this.detailCustomer.national_code ? this.detailCustomer.national_code : "")
        if(typeof(this.detailCustomer.image) === 'string' || this.detailCustomer.image === null){
            formData.append('image','')
        }else{
            formData.append('image',this.detailCustomer.image)
        }
        // update Customer
        onlineFactorService.updateCustomer(this.hashid,formData).then(response=>{
            if(response.status === 200){
                this.$router.push('/customers')
            }
        }).catch(({response}) => {
            this.toastr.error(response.data.message)
            for(let err in response.data.data){
                this.toastr.error(response.data.data[err][0])
            }
        }).finally(()=>{
          KTApp.unprogress(btn)
        })
      },
        currencyFormat(price) {
            price = Math.floor(price / 10);
            const pieces = parseFloat(price).toFixed(0).split('');
            let ii = pieces.length;

            while ((ii -= 3) > 0) {
                pieces.splice(ii, 0, ',');
            }

            return pieces.join('');
        },
        processFile(e) {
        this.detailCustomer.image = e.target.files[0]
            let output = document.getElementById('logo_preview');
            output.src = URL.createObjectURL(e.target.files[0]);
            output.onload = function() {
                URL.revokeObjectURL(output.src) // free memory
            }
        },
    },
}
</script>
<style scoped>

.preview_img {
    max-width: 70px;
    max-height: 70px;
    position: absolute;
    top: 10px;
    left: 80px;
}

.optionCityDetails{
    margin: -2rem 1rem 0 0;
}

.create-services {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-end;
    }
</style>